import { useHistory, useParams } from "react-router-dom";

export function useNavigate() {
  const history = useHistory();
  const { lang } = useParams<{ lang: string }>();
  const navigate = (route: string) => history.push(`${lang ? `/${lang}` : ''}${route}`);
  return navigate;
}